import * as React from "react";
import PropTypes from "prop-types";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import MenuIcon from "@mui/icons-material/Menu";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import logo from "../images/logo_DLS.png";
//import logo2 from "../images/logo_DLS2.png";
import { useNavigate } from "react-router-dom";
import Fab from "@mui/material/Fab";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";

const drawerWidth = 210;

function Navbar(props) {
  const { windows } = props;
  const [mobileOpen, setMobileOpen] = React.useState(false);

  const [activeButton, setActiveButton] = React.useState("home");
  const navigate = useNavigate();

  const handleButtonClick = (button, path) => {
    setActiveButton(button);
    navigate(path); // Cambia a la ruta especificada
  };

  const onClickwp = () => {
    window.open(
      "https://api.whatsapp.com/send/?phone=59173587107&text&type=phone_number&app_absent=0",
      "_blank",
    );
  };

  const handleDrawerToggle = () => {
    setMobileOpen((prevState) => !prevState);
  };

  const drawer = (
    <Box
      onClick={handleDrawerToggle}
      sx={{
        textAlign: "center",
        background: "#077f83",
        color: "#DCFFCC",
        height: "100%",
      }}
    >
      <Box
        sx={{
          width: "100%",
          height: "auto",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <img
          src={logo}
          alt="DSL Digital Language Services"
          className="img-dim"
        />
      </Box>
      <Divider />
      <List>
        <ListItem disablePadding>
          <ListItemButton
            sx={{
              textAlign: "center",
              display: "block",
              borderBottom:
                activeButton === "home" ? "1px solid white" : "none",
            }}
          >
            <ListItemText
              primary="INICIO"
              color={activeButton === "home" ? "primary" : "titulos"}
              onClick={() => handleButtonClick("home", "/")}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            sx={{
              textAlign: "center",
              display: "block",

              borderBottom:
                activeButton === "cursos" ? "1px solid white" : "none",
            }}
          >
            <ListItemText
              primary="CURSOS"
              color={activeButton === "cursos" ? "primary" : "titulos"}
              onClick={() => handleButtonClick("cursos", "/cursos")}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            sx={{
              textAlign: "center",
              display: "block",

              borderBottom:
                activeButton === "toefl" ? "1px solid white" : "none",
            }}
          >
            <ListItemText
              primary="TOEFL"
              color={activeButton === "toefl" ? "primary" : "titulos"}
              onClick={() => handleButtonClick("toefl", "/toefl")}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            sx={{
              textAlign: "center",
              display: "block",

              borderBottom:
                activeButton === "calendario" ? "1px solid white" : "none",
            }}
          >
            <ListItemText
              primary="FECHA DE EXAMENES"
              color={activeButton === "calendario" ? "primary" : "titulos"}
              onClick={() => handleButtonClick("calendario", "/calendario")}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            sx={{
              textAlign: "center",
              display: "block",

              borderBottom:
                activeButton === "traducciones" ? "1px solid white" : "none",
            }}
          >
            <ListItemText
              primary="TRADUCCIONES"
              color={activeButton === "traducciones" ? "primary" : "titulos"}
              onClick={() => handleButtonClick("traducciones", "/traducciones")}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            sx={{
              textAlign: "center",
              display: "block",

              borderBottom:
                activeButton === "contactos" ? "1px solid white" : "none",
            }}
          >
            <ListItemText
              primary="CONTACTOS"
              color={activeButton === "contactos" ? "primary" : "titulos"}
              onClick={() => handleButtonClick("contactos", "/contactos")}
            />
          </ListItemButton>
        </ListItem>
        <ListItem disablePadding>
          <ListItemButton
            sx={{
              textAlign: "center",
              display: "block",
              borderBottom:
                activeButton === "videos" ? "1px solid white" : "none",
            }}
          >
            <ListItemText
              primary="VIDEOS"
              color={activeButton === "videos" ? "primary" : "titulos"}
              onClick={() => handleButtonClick("videos", "/videos")}
            />
          </ListItemButton>
        </ListItem>
      </List>
    </Box>
  );

  const container =
    windows !== undefined ? () => window().document.body : undefined;
  /*color lila 512676 */
  return (
    <Box
      sx={{
        width: "auto",
        justifyContent: "center",
        display: "flex",
      }}
    >
      <CssBaseline />
      <AppBar component="nav" color="secondary" sx={{ alignItems: "center" }}>
        <Toolbar
          sx={{
            width: {
              xs: "95vw",
              sm: "90vw",
              md: "70vw",
            },
          }}
        >
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={{ mr: 2, display: { sm: "block", md: "none" } }}
          >
            <MenuIcon />
          </IconButton>
          <Typography
            variant="h6"
            component="div"
            sx={{
              flexGrow: 1,
              display: { xs: "none", sm: "none", md: "block" },
            }}
          >
            <Box sx={{ width: "120px", height: "auto", display: "flex" }}>
              <img
                src={logo}
                alt="DSL Digital Language Services"
                className="img-dim"
              />
            </Box>
          </Typography>
          <Box sx={{ display: { xs: "none", sm: "none", md: "block" } }}>
            <Box
              sx={{
                display: "inline",
                paddingBottom: "10px",
                borderBottom:
                  activeButton === "home" ? "1px solid white" : "none",
              }}
            >
              <Button
                color={activeButton === "home" ? "primary" : "titulos"}
                onClick={() => handleButtonClick("home", "/")}
              >
                INICIO
              </Button>
            </Box>
            <Box
              sx={{
                display: "inline",
                paddingBottom: "10px",
                borderBottom:
                  activeButton === "cursos" ? "1px solid white" : "none",
              }}
            >
              <Button
                color={activeButton === "cursos" ? "primary" : "titulos"}
                onClick={() => handleButtonClick("cursos", "/cursos")}
              >
                CURSOS
              </Button>
            </Box>
            <Box
              sx={{
                display: "inline",
                paddingBottom: "10px",
                borderBottom:
                  activeButton === "toefl" ? "1px solid white" : "none",
              }}
            >
              <Button
                color={activeButton === "toefl" ? "primary" : "titulos"}
                onClick={() => handleButtonClick("toefl", "/toefl")}
              >
                TOEFL
              </Button>
            </Box>
            <Box
              sx={{
                display: "inline",
                paddingBottom: "10px",
                borderBottom:
                  activeButton === "calendario" ? "1px solid white" : "none",
              }}
            >
              <Button
                color={activeButton === "calendario" ? "primary" : "titulos"}
                onClick={() => handleButtonClick("calendario", "/calendario")}
              >
                FECHAS DE EXAMENES
              </Button>
            </Box>
            <Box
              sx={{
                display: "inline",
                paddingBottom: "10px",
                borderBottom:
                  activeButton === "traducciones" ? "1px solid white" : "none",
              }}
            >
              <Button
                color={activeButton === "traducciones" ? "primary" : "titulos"}
                onClick={() =>
                  handleButtonClick("traducciones", "/traducciones")
                }
              >
                TRADUCCIONES
              </Button>
            </Box>
            <Box
              sx={{
                display: "inline",
                paddingBottom: "10px",
                borderBottom:
                  activeButton === "contactos" ? "1px solid white" : "none",
              }}
            >
              <Button
                color={activeButton === "contactos" ? "primary" : "titulos"}
                onClick={() => handleButtonClick("contactos", "/contactos")}
              >
                CONTACTOS
              </Button>
            </Box>
            <Box sx={{ display: "inline", borderLeft: "1px solid white" }}>
              <Button
                color={activeButton === "videos" ? "primary" : "titulos"}
                onClick={() => handleButtonClick("videos", "/videos")}
              >
                VIDEOS
              </Button>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>
      <nav>
        <Drawer
          container={container}
          variant="temporary"
          open={mobileOpen}
          onClose={handleDrawerToggle}
          ModalProps={{
            keepMounted: true, // Better open performance on mobile.
          }}
          sx={{
            display: { xs: "block", sm: "block", md: "none" },
            "& .MuiDrawer-paper": {
              boxSizing: "border-box",
            },
          }}
        >
          {drawer}
        </Drawer>
      </nav>
      <Box sx={{ maxWidth: "70vw", display: "flex" }}>
        <Box
          component="main"
          sx={{
            p: 2,
          }}
        >
          <Toolbar />
          <Fab
            color="whatsapp"
            aria-label="add"
            sx={{
              position: "fixed",
              display: "flex",
              bottom: "3vw",
              right: "3vw",
            }}
          >
            <WhatsAppIcon
              fontSize="large"
              color="primary"
              onClick={onClickwp}
            />
          </Fab>
        </Box>
      </Box>
    </Box>
  );
}

Navbar.propTypes = {
  window: PropTypes.func,
};

export default Navbar;
